/**
 * @summary     app.config.js
 * @description App JS Config Controller
 * @version     1.0
 	> 1.0 Initial version
		- 02/10/2019
 * @file        app.config.js
 * @author      Silas Garrison
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"config",
	function(){
		"use strict";

		/*
			Default settings which will be accessible to the outside API via app.config[paramName]
		*/
		var settings = {
			urlAbout : "https://inspections.myhealthdepartment.com/",
			supportEmail : "support@myhealthdepartment.com",
			name : "My Health Department",
			version : "1.0.0",
			releaseDate : "02/10/2019",
			apiURL : document.location.origin + '/',
			isProduction : true,
			isiOS : !!(navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPhone/i)),
			isAndroid : !!(navigator.userAgent.match(/Android/i)),
			colors : {}
		};

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes component
		*/
		function init(){}

		/*
			Expose API variables
		*/
		app.utils.copy(settings,this,true,false);

		this.init = init;

		return this;
	}
);
